import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, ArrowRight, Zap, RefreshCw, RotateCcw } from 'lucide-react';
export function ResetSlide() {
  return <div className="h-full grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-340">
      {/* Left Column: Quote + Text Content */}
      <div className="flex flex-col gap-4 overflow-hidden" data-id="element-341">
        {/* Sequoia quote */}
        <motion.div initial={{
        opacity: 0,
        y: -12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="shrink-0 rounded-lg overflow-hidden shadow-md border border-gray-700 max-w-xs" data-id="element-342">
          <img src="https://cdn.magicpatterns.com/uploads/fe53pMefsA8SixeudDSB6Q/Screenshot_2026-04-07_at_11.44.16.png" alt="Julien Bek, Partner at Sequoia Capital: The next $1T company will be a software company masquerading as a services firm." className="w-full h-auto object-contain" data-id="element-343" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} className="space-y-4" data-id="element-344">
          <div className="flex items-center gap-3 text-purple-600 font-mono text-sm tracking-wider uppercase" data-id="element-345">
            <RefreshCw className="w-4 h-4" data-id="element-346" />
            Market Shift
          </div>

          <ul className="space-y-4" data-id="element-347">
            <li className="flex items-start gap-3" data-id="element-348">
              <div className="mt-1 p-1.5 rounded bg-red-50 text-red-600" data-id="element-349">
                <TrendingDown className="w-4 h-4" data-id="element-350" />
              </div>
              <div data-id="element-351">
                <h3 className="text-lg font-semibold text-gray-900 mb-0.5" data-id="element-352">
                  SaaS Panic
                </h3>
                <p className="text-gray-500 text-sm" data-id="element-353">
                  IQVIA -15%, broader stocks -27% to -51%.
                </p>
              </div>
            </li>

            <li className="flex items-start gap-3" data-id="element-354">
              <div className="mt-1 p-1.5 rounded bg-orange-50 text-orange-600" data-id="element-355">
                <Zap className="w-4 h-4" data-id="element-356" />
              </div>
              <div data-id="element-357">
                <h3 className="text-lg font-semibold text-gray-900 mb-0.5" data-id="element-358">
                  Per-seat models obsolete
                </h3>
                <p className="text-gray-500 text-sm" data-id="element-359">
                  AI reduces users, breaking traditional pricing.
                </p>
              </div>
            </li>

            <li className="flex items-start gap-3" data-id="element-360">
              <div className="mt-1 p-1.5 rounded bg-purple-50 text-purple-600" data-id="element-361">
                <ArrowRight className="w-4 h-4" data-id="element-362" />
              </div>
              <div data-id="element-363">
                <h3 className="text-lg font-semibold text-gray-900 mb-0.5" data-id="element-364">
                  Shift to Service-as-Software
                </h3>
                <p className="text-gray-500 text-sm" data-id="element-365">
                  Outcome-as-Agentic models taking over.
                </p>
              </div>
            </li>

            <li className="flex items-start gap-3" data-id="element-366">
              <div className="mt-1 p-1.5 rounded bg-emerald-50 text-emerald-600" data-id="element-367">
                <RotateCcw className="w-4 h-4" data-id="element-368" />
              </div>
              <div data-id="element-369">
                <h3 className="text-lg font-semibold text-gray-900 mb-0.5" data-id="element-370">
                  DIY → Full Service Again
                </h3>
                <p className="text-gray-500 text-sm" data-id="element-371">
                  Customers moving back from DIY tools to full-service delivery.
                </p>
              </div>
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="p-4 rounded-xl bg-purple-50 border border-purple-200" data-id="element-372">
          <div className="text-sm text-purple-600 mb-1 font-medium" data-id="element-373">
            Valuation Reset SaS
          </div>
          <div className="flex items-baseline gap-2" data-id="element-374">
            <span className="text-3xl font-bold text-gray-900" data-id="element-375">20x+</span>
            <span className="text-gray-500 text-sm" data-id="element-376">ARR standard</span>
          </div>
          <div className="text-sm text-gray-400 mt-0.5" data-id="element-377">
            Top AI-native 25–50x revenue
          </div>
        </motion.div>
      </div>

      {/* Right Column: Figma Stock Chart — fixed height */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.4
    }} className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm bg-white h-full max-h-[calc(100vh-220px)]" data-id="element-378">
        <img src="https://cdn.magicpatterns.com/uploads/caXuE1WmY9PoQoNczH5rMa/Screenshot_2026-04-16_at_08.51.56.png" alt="Figma (FIG) Stock Performance — Massive Post-IPO Decline, ~86% from all-time high" className="w-full h-full object-contain object-top" data-id="element-379" />
      </motion.div>
    </div>;
}